export default "__VITE_ASSET__psljc2C9AZAdwJzcSWYkWg__";